"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UvApi_1 = __importDefault(require("./UvApi"));
var main_1 = __importDefault(require("../main"));
var NotyTypes_1 = __importDefault(require("./NotyTypes"));
var UvApiAuth = /** @class */ (function (_super) {
    __extends(UvApiAuth, _super);
    function UvApiAuth() {
        var _this = _super.call(this) || this;
        _this.handleError = function (error) {
            //console.log(`UvApiAuth handleError ${error}`);
            //console.log(`${error.response.status}`);
            //console.log(`${error}`);
            /*
                 * Server responds with Forbid 403 from dashboard/get
                 * when user is auth'd with auth0 (and hence API) but not found in local DB
                 * might be better idea to have two totally speparate apps in Auth0
                 * to separate out local, staging and prod users
                 * but that would mean a lot of messing with auth0 IDs in db's
                 * N.B. we could instead use vueApp.$auth.logout() here and change
                 * this page to provide a diff msg and login button
            */
            if (error.response.status === 403) {
                /*
                 * N.B. we could instead use vueApp.$auth.logout() here and change
                 * this page to provide a diff msg and login button
                */
                main_1.default.$router.push("/auth/fail");
            }
            else {
                //console.log(`UvApiAuth handleError still runs after pushing the auth/fail route`);
                main_1.default.$notify({
                    timeout: 10000,
                    message: "Problem on server\r\n" + error,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes_1.default[NotyTypes_1.default.danger]
                });
            }
            return Promise.reject(error); ///seems we Do want this... else calling code tried to use the response | or maybe bit of vue or axios or something gets upset...
            //not sure we want to do this ::: return Promise.reject(error); //so added Promise<never> | void to HttpClient
        };
        _this.instance.interceptors.request.use(function (config) { return __awaiter(_this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, main_1.default.$auth.getTokenSilently()];
                    case 1:
                        token = _a.sent();
                        config.headers['Authorization'] = "Bearer " + token;
                        return [2 /*return*/, config];
                }
            });
        }); }, _this.handleError);
        _this.instance.interceptors.response.use(function (response) {
            return response;
        }, _this.handleError);
        return _this;
    }
    return UvApiAuth;
}(UvApi_1.default));
exports.default = UvApiAuth;
//# sourceMappingURL=UvApiAuth.js.map